import { UserPermisssions } from '@constants/common';
import { RootState } from '@store/store';
import { useSelector } from 'react-redux';

const usePermissions = () => {
  const { userPermissions, permissionsLoaded } = useSelector(
    (state: RootState) => state.rootReducer.Users
  );

  const hasPermission = (permission: UserPermisssions) =>
    userPermissions.includes(permission);

  return { hasPermission, permissionsLoaded, userPermissions };
};

export default usePermissions;
